// src/App.js - UPDATED WITH CONDITIONAL NAVBAR & LEGAL ROUTES
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/Auth/PrivateRoute';
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';

// Auth Pages
import Login from './components/Auth/Login';
import Signup from './components/Auth/Signup';

// Main Pages
import Dashboard from './pages/Dashboard';
import ShippingForm from './pages/ShippingForm';
import Profile from './pages/Profile';
import BOLGenerator from './pages/BOLGenerator';

// Admin Pages
import AdminDashboard from './pages/adminDashboard';
import DriverManagement from './pages/driverManagement';

// Public Pages
import PublicDashboard from './pages/PublicDashboard';
import QuoteForm from './pages/QuoteForm';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';

// Driver Signature Page
import DriverSignature from './pages/DriverSignature';

// Styles
import './App.css';

// Debug component to check environment variables
function EnvironmentDebug() {
  React.useEffect(() => {
    console.log('=== ENVIRONMENT DEBUG INFO ===');
    console.log('Current environment:', process.env.NODE_ENV);
    console.log('REACT_APP_STRIPE_PUBLISHABLE_KEY is set:', !!process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
    console.log('Stripe key starts with:', process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ? process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY.substring(0, 20) : 'KEY NOT FOUND');
    console.log('Is live key?', process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ? process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY.startsWith('pk_live_') : false);
    console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
    console.log('=== END DEBUG INFO ===');
  }, []);

  return null;
}

// Component to conditionally show Navbar and Footer
function Layout({ children }) {
  const location = useLocation();
  
  // Don't show Navbar/Footer on driver signature pages
  const isDriverSignaturePage = location.pathname.includes('/driver-signature');
  
  if (isDriverSignaturePage) {
    return <div className="min-h-screen bg-gray-50">{children}</div>;
  }
  
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <main className="flex-grow">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <EnvironmentDebug />
        <Layout>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<PublicDashboard />} />
            <Route path="/quote" element={<QuoteForm />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            
            {/* Driver Signature Route (Public - no auth required, no navbar) */}
            <Route path="/driver-signature/:shipmentId" element={<DriverSignature />} />
            
            {/* Private Routes - Regular Users */}
            <Route element={<PrivateRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/shipping-form" element={<ShippingForm />} />
              <Route path="/profile" element={<Profile />} />
            </Route>

            {/* Admin-only Routes */}
            <Route element={<PrivateRoute requireAdmin={true} />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/drivers" element={<DriverManagement />} />
              <Route path="/bol-generator/:shipmentId?" element={<BOLGenerator />} />
            </Route>

            {/* Catch-all route for 404 */}
            <Route path="*" element={
              <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                  <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
                  <p className="text-xl text-gray-600 mb-8">Page not found</p>
                  <a href="/" className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors">
                    Go Home
                  </a>
                </div>
              </div>
            } />
          </Routes>
        </Layout>
      </AuthProvider>
    </Router>
  );
}

export default App;